import { getOptionsFromDefinition } from '../../../../support/helpers/CategoryOptions';
import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

export function ensureDefaultSelected(
  definition_: FormFieldDefinition,
  selected: Array<string> | null | undefined,
): Array<string> {
  let definition: ObjectOf<unknown> = definition_;
  let isEmpty = selected == null || selected.length === 0;
  if (isEmpty && !definition.allow_multi) {
    const options = getOptionsFromDefinition(definition);
    return [options[0]?.id ?? ''];
  } else {
    return selected || [];
  }
}

export function getType(definition_: FormFieldDefinition) {
  let definition: ObjectOf<unknown> = definition_;
  if (definition.condensed) {
    return 'dropdown';
  }
  return definition.allow_multi ? 'checkbox-group' : 'radio-group';
}
